import React, {useState} from 'react';
import {Grid, IconButton, Stack, Typography} from "@mui/material";
import Divider from "@mui/material/Divider";
import {useQuery, useQueryClient} from "react-query";
import ModalDeleteProgram from "./modals/ModalDeleteProgram";
import ModalAddProgram from "./modals/ModalAddProgram";
import {getPlanListApi} from "../../../../api/AdminApi";
import FlexGrid from "../../../../components/Admin/flexGrid/FlexGrid";
import Loading from "../../../../components/Site/Loading/Loading";
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import {fixStringToTextView} from "../../../../tools/helper";

const DashboardPrograms = () => {
    const [plan, setPlan] = useState(null);
    const [itemsId, setItemsId] = useState(0)


    // dev react query method
    const getPlanList = async () => {
        try {
            const res = await getPlanListApi();
            return res?.data?.data

        } catch (e) {

        }
    }

    const client = useQueryClient();
    const invalidateData = async () => {
        await client.invalidateQueries('program_List')
    }

    const {
        isLoading,
        data: programList,
        error
    } = useQuery(['program_List'], getPlanList);

    if (error) return <div>An error accrued : {error.message}</div>
    if (isLoading) return <Loading/>
    return (
        <Grid container>
            {/*Content Header*/}
            <Typography variant="h6" component="h2"
                        sx={{fontWeight: '600', lineHeight: "38px", margin: "auto", mt: 3}}>
                برنامه ها
            </Typography>

            <Divider sx={{
                width: '100%',
                mb: 4,
                mt: 2,
                height: '2px',
                backgroundColor: 'rgb(89, 46, 169)',
                boxShadow: ' -2px 2px 6px -1px rgb(89, 46, 169)',
            }}/>


            <Grid item xs={12}>
                <Grid item xs={12}>
                    <FlexGrid justifyContent={'space-between'} px={4}>
                        <Typography>
                            نام برنامه
                        </Typography>

                        <IconButton onClick={() => setPlan({})}>
                            <AddCircleOutlineRoundedIcon sx={{color: 'rgba(89, 46, 169, 1)'}}/>
                        </IconButton>
                    </FlexGrid>

                    <Divider sx={{width: '100%'}}/>
                    <Stack>
                        {programList?.map((item, index) => {

                            return (
                                <Stack
                                    sx={{bgcolor: index % 2 === 0 ? '#fff' : 'rgba(89, 46, 169, 0.18)', px: 4, my: 0.5}}
                                    key={index} direction={'row'} justifyContent={'space-between'}
                                    alignItems={'center'}>
                                    <Typography>
                                        {fixStringToTextView(item?.name)}
                                    </Typography>

                                    <FlexGrid>
                                        <IconButton onClick={() => setPlan(item)} sx={{mx: 2}}>
                                            <EditOutlinedIcon sx={{fontSize: "27px", color: "rgba(89, 46, 169, 1)"}}/>
                                        </IconButton>
                                        <IconButton onClick={() => setItemsId(item.id)}>
                                            <DeleteIcon sx={{color: "rgba(89, 46, 169, 1)"}}/>
                                        </IconButton>
                                    </FlexGrid>
                                </Stack>
                            )
                        })}
                    </Stack>
                </Grid>

                {itemsId > 0 &&
                    <ModalDeleteProgram open={itemsId > 0} close={() => setItemsId(0)} itemId={itemsId}
                                        invalidateData={invalidateData}/>}

                {
                    plan !== null &&
                    <ModalAddProgram open={true} close={() => setPlan(null)} planItem={plan} invalidateData={invalidateData}/>}

            </Grid>
        </Grid>
    )
}

export default DashboardPrograms;